<template>
  <router-link v-if="!blank" class="base-link" :to="to">
    <slot></slot>
  </router-link>
  <a class="base-link" v-else :href="to" target="_blank" rel="noopener noreferrer">
    <slot></slot>
  </a>
</template>

<script>
  export default {
    props: {
      blank: Boolean,
      to: {
        type: [String, Object],
        reqired: true
      }
    }
  }
</script>

<style lang="scss">
  @import './src/assets/styles/colors.scss';
  
  .base-link {
    color: $color-lochmara;

    &:focus {
      outline: 2px solid $color-purple;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/base/BaseLink.vue